import { useIconColors } from 'Context/IconColorContext';
import React from 'react';
import { FiCheckCircle as CheckCircle,  FiXCircle as XCircle, FiMinusCircle as MinusCircle, FiClock as Clock, FiCheckSquare  as CheckCircle2 } from 'react-icons/fi';
import { FiBell as Bell } from 'react-icons/fi';  // Replaces `Bell`

interface IconProps {
    tipo: number;
    style?: React.CSSProperties;
}
const EventIcon: React.FC<IconProps> = ({ tipo, style }) => {
    const iconColors = useIconColors();
    const getIcon = () => {
        if (!iconColors) {
            return <MinusCircle color="#6B7278" style={style} />;
        }
        const iconInfo = iconColors.find(icon => icon.id === tipo);

        if (!iconInfo) {
            return <MinusCircle color="#6B7278" style={style} />;
        }

        switch (tipo) {
            case -1:
                return <XCircle color={iconInfo.color} style={style} />;
            case 0:
                return <MinusCircle color={iconInfo.color} style={style} />;
            case 1:
                return <CheckCircle color={iconInfo.color} style={style} />;
            case 2:
            case 3:
                return <Clock color={iconInfo.color} style={style} />;
            case 4:
                return <CheckCircle2 color={iconInfo.color} style={style} />;
            case 9:
                return <Bell color={iconInfo.color} style={style} />;
            case 10: 
                return <Clock color={iconInfo.color} style={style} />;
            default:
                return <Bell color={iconInfo.color} style={style} />;
        }
    };

    return getIcon();
};

export default EventIcon;
